import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  Navbar,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap";

import NAERlogo from "../Images/NAER logo.png";

class navBar extends Component {
  state = {};
  render() {
    return (
      <div className="navbar-group">
        <Navbar expand="lg" className="fixed-top navbar1">
          <Navbar.Brand>
            <Link className="logo" to="/logo">
              <img src={NAERlogo} alt="logo" width="50" height="50" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="mr-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <div className=" text-center">
                <Nav.Link>
                  <Link className="navItem" to="/intro">
                    Home
                  </Link>
                </Nav.Link>
              </div>
              <div className="text-center">
                <Nav.Link>
                  <Link className="navItem" to="/history">
                    History
                  </Link>
                </Nav.Link>
              </div>
              <NavDropdown
                className="navItem text-center"
                title="Services"
                // id="navbarScrollingDropdown"
              >
                <NavDropdown.Item>
                  <Link to="/communication">Communication Disorders</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link to="/research">Educational Research</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link to="/journal">Journal, Article & Publication</Link>
                </NavDropdown.Item>
              </NavDropdown>
              <div className="text-center">
                <Nav.Link>
                  <Link className="navItem" to="/contact">
                    Contact
                  </Link>
                </Nav.Link>
              </div>
            </Nav>
            <Form className="d-flex">
              <FormControl
                type="search"
                placeholder="Search"
                className="mr-2"
                aria-label="Search"
              />
              <Button variant="outline-success">Search</Button>
            </Form>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}

export default navBar;
